// Протокол измерений усилий натяжения в канатах оттяжек мачты (1,3,4 вкладка готовы)
import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  CCard,
  CCardBody,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CButton,
  CFormTextarea,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CFormInput,
  CFormSelect,
  CSpinner
} from "@coreui/react";
import PhotoTab from './Tabs/PhotoTab';
import AddTensionsMeasurements from './Tabs/AddTensionsMeasurements'; 

const ProtocolTensions = ({ ldoc, nvalue, activeProtocolId, refreshProtocols }) => {
  const [activeKey, setActiveKey] = useState(1);
  const [groupedData, setGroupedData] = useState({});
  const [normativeDocs, setNormativeDocs] = useState([]);
  const [measurementToolsOptions, setMeasurementToolsOptions] = useState([]);
  const [measurementConductedByOptions, setMeasurementConductedByOptions] = useState([]);
  const [developedByOptions, setDevelopedByOptions] = useState([]);
  const [normativeDocsList, setNormativeDocsList] = useState([]);
  const [measurementToolsList, setMeasurementToolsList] = useState([]);
  const [peopleList, setPeopleList] = useState([]);
  const [dateMeasurement, setDateMeasurement] = useState("");
  const [dateProtocol, setDateProtocol] = useState("");
  const [newProtocolId, setNewProtocolId] = useState(null);
  const [photoTabProtocolId, setPhotoTabProtocolId] = useState(null);
  const [selectedNormativeDoc, setSelectedNormativeDoc] = useState('');
  const [selectedMeasurementTool, setSelectedMeasurementTool] = useState('');
  const [selectedConductedBy, setSelectedConductedBy] = useState('');
  const [selectedDevelopedBy, setSelectedDevelopedBy] = useState('');
  // --- Вкладка 3: Вывод ---
  const [conclusion, setConclusion] = useState("");
  // --- Вкладка 3: Вывод ---
  // --- Поля для числовых значений ---
  const [baseWidth, setBaseWidth] = useState("");
  const [beltDiameter, setBeltDiameter] = useState("");
  // --- Поля для числовых значений ---
  const [isLoading, setIsLoading] = useState(false);
  
  // Состояние для модального окна
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  // Состояние для данных таблицы во вкладке 2 (временно, для демонстрации)
  const [measurementsData, setMeasurementsData] = useState([]);

  const token = localStorage.getItem("token");
  const getIdByName = (name, list) => {
    if (!name || !list || !Array.isArray(list)) return null;
    const item = list.find((item) => item.name === name);
    return item ? item.Id : null;
  };
  function formatDateToISO(originalDate) {
    if (!originalDate) return "";
    const parts = originalDate.split('.');
    if (parts.length !== 3) return "";
    const [day, month, year] = parts;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }
  useEffect(() => {
    setPhotoTabProtocolId(activeProtocolId || newProtocolId || null);
  }, [activeProtocolId, newProtocolId]);
  useEffect(() => {
    if (ldoc && nvalue !== null) {
      setIsLoading(true);
      axios
        .get(`/api/ldoc/${ldoc}/protocol-info/${nvalue}/`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const result = response.data.data || [];
          const grouped = {};
          const normativeList = [];
          const measurementToolsListTemp = [];
          const peopleListTemp = [];
          const developedByList = [];
          const normativeDocsListTemp = [];
          const measurementToolsListWithId = [];
          const peopleListWithId = [];
          result.forEach((item) => {
            const key = item[""]?.trim();
            const value = item.ObjName;
            if (!key) return;
            switch (key) {
              case "Нормативные документы":
                if (value) {
                  normativeList.push(value);
                  normativeDocsListTemp.push({ Id: item.Id, name: value });
                }
                break;
              case "Средства измерений":
                if (value) {
                  measurementToolsListTemp.push(value);
                  measurementToolsListWithId.push({ Id: item.Id, name: value });
                }
                break;
              case "Измерения проводил":
                if (value) {
                  peopleListTemp.push({ Id: item.Id, name: value });
                }
                break;
              case "Разработал":
                if (value) {
                  developedByList.push(value);
                }
                break;
              default:
                if (key !== "Выводить значения") {
                  grouped[key] = value;
                }
            }
          });
          setNormativeDocsList(normativeDocsListTemp);
          setMeasurementToolsList(measurementToolsListWithId);
          setPeopleList(peopleListWithId);
          setGroupedData(grouped);
          setNormativeDocs(normativeList);
          setMeasurementToolsOptions(measurementToolsListTemp);
          setMeasurementConductedByOptions(peopleListTemp.map(p => p.name));
          setDevelopedByOptions(developedByList);
          setSelectedNormativeDoc(normativeList[0] || "");
          setSelectedMeasurementTool(measurementToolsListTemp[0] || "");
          setSelectedConductedBy(peopleListTemp.length > 0 ? peopleListTemp[0].name : "");
          setSelectedDevelopedBy(developedByList[0] || "");
          setDateMeasurement(grouped["Дата проведения измерений"] || "");
          setDateProtocol(grouped["Дата протокола"] || "");
          // --- Загрузка данных при редактировании ---
          if (activeProtocolId) {
            axios.get(`/api/protocol-details/${activeProtocolId}/`, {
              headers: { Authorization: `Bearer ${token}` },
            })
              .then(response => {
                const data = response.data.data;
                if (data && data.length >= 18) {
                  setSelectedNormativeDoc(data[4]?.Value || normativeList[0] || "");
                  setSelectedMeasurementTool(data[5]?.Value || measurementToolsListTemp[0] || "");
                  setSelectedConductedBy(data[9]?.Value || (peopleListTemp.length > 0 ? peopleListTemp[0].name : ""));
                  setSelectedDevelopedBy(data[16]?.Value || developedByList[0] || "");
                  setDateMeasurement(formatDateToISO(data[10]?.Value) || "");
                  setDateProtocol(formatDateToISO(data[3]?.Value) || "");
                  // --- Загрузка Вывода ---
                  setConclusion(data[17]?.Value || ""); // Предполагаем индекс 17 для Conclusion
                  // --- Загрузка Вывода ---
                  // --- Загрузка числовых значений ---
                  setBaseWidth(data[6]?.Value || ""); // Предполагаем индекс 6
                  setBeltDiameter(data[7]?.Value || ""); // Предполагаем индекс 7
                  // --- Загрузка числовых значений ---
                }
              })
              .catch(error => {
                console.error(`Ошибка загрузки деталей протокола ${activeProtocolId}:`, error);
              })
              .finally(() => {
                 // setIsLoading(false); // Уберем, так как он устанавливается в finally ниже
              });
          } else {
              setConclusion("");
              setNewProtocolId(null);
              // --- Сброс числовых значений ---
              setBaseWidth("");
              setBeltDiameter("");
              // --- Сброс числовых значений ---
          }
          // --- Загрузка данных при редактировании ---
        })
        .catch((error) => {
          console.error("Ошибка загрузки данных протокола:", error);
        })
        .finally(() => {
           setIsLoading(false);
        });
    }
  }, [ldoc, nvalue, token, activeProtocolId]);
  
  const saveData = () => {
    const effectiveProtocolId = newProtocolId || activeProtocolId || 0;
    const formattedDateProtocol = dateProtocol ? new Date(dateProtocol).toISOString() : null;
    const formattedDateMeasurement = dateMeasurement ? new Date(dateMeasurement).toISOString() : null;
    // --- Преобразование числовых значений ---
    const baseWidthValue = parseFloat(baseWidth) || 0;
    const beltDiameterValue = parseFloat(beltDiameter) || 0;
    // --- Преобразование числовых значений ---
    const payload = {
      Id: effectiveProtocolId,
      Name: "Протокол измерений усилий натяжения в канатах оттяжек мачты",
      ProtocolDate: formattedDateProtocol,
      idMeasuring: getIdByName(selectedMeasurementTool, measurementToolsList),
      idSpecObserver: getIdByName(selectedConductedBy, peopleList),
      idDoc: getIdByName(selectedNormativeDoc, normativeDocsList),
      idPhoto: null,
      ProtocolNum: groupedData["№ протокола"] || "",
      // --- Использование числовых значений ---
      BaseWidth: baseWidthValue,
      BeltDiameter: beltDiameterValue,
      // --- Использование числовых значений ---
      SchemaNum: 0,
      DateMeasuring: formattedDateMeasurement,
      idSpecExec: getIdByName(selectedDevelopedBy, peopleList),
      AxisRotate: 0,
      LocationDist: "",
      LocationPoints: "",
      DiscrepBetween: "",
      AvgError: "",
      NType: 2,
      // --- Использование Conclusion из состояния ---
      Conclusion: conclusion,
      // --- Использование Conclusion из состояния ---
      RelRollerBelt: 0,
      IsAvgValueDevice: false,
      idProject: 456,
      idNormDocuments: getIdByName(selectedNormativeDoc, normativeDocsList)?.toString() || "",
      idMeasurings: getIdByName(selectedMeasurementTool, measurementToolsList)?.toString() || "",
      Gost: selectedNormativeDoc || "",
      IsOutputHide: false,
      Note: "",
      TotalPages: 1,
      IsAllowPlanHeights: false,
      IsWorkNotTech: false,
      LDoc: ldoc
    };
    console.log('Отправляемый payload Tensions Protocol:', payload);
    setIsLoading(true);
    axios.post('/api/protocol/save/', payload, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        console.log("Ответ от сервера при сохранении Tensions Protocol:", response.data);
        if (!newProtocolId && response.data.protocol_id) {
            const createdProtocolId = response.data.protocol_id;
            console.log("Создан новый протокол Tensions с ID:", createdProtocolId);
            setNewProtocolId(createdProtocolId);
            if (!photoTabProtocolId) {
               setPhotoTabProtocolId(createdProtocolId);
            }
        } else {
            console.log("Обновлен протокол Tensions с ID:", effectiveProtocolId);
        }
        console.log(response.data.message || "Протокол успешно сохранен/обновлен");
        if (refreshProtocols) {
          refreshProtocols();
        }
        alert(response.data.message || "Протокол успешно сохранен/обновлен");
      })
      .catch((error) => {
        console.error("Ошибка сохранения/обновления протокола Tensions:", error);
        alert("Ошибка при сохранении/обновлении протокола: " + (error.response?.data?.message || error.message));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Функции для работы с модальным окном
  const handleOpenAddModal = () => {
    setIsAddModalVisible(true);
  };

  const handleSaveMeasurement = (data) => {
    console.log('Сохранение данных измерения:', data);
    // TODO: Реализуйте логику сохранения данных
    // Например, отправка на сервер или обновление локального состояния
    // Пока просто добавим в локальное состояние для демонстрации
    setMeasurementsData(prev => [...prev, {
      floor: data.floorNumber,
      brand: data.tableRows.map(r => r.brand).join(', '), // Просто для примера
      tension: data.tableRows.map(r => r.tension).join(', '), // Просто для примера
      // В реальности нужно будет хранить данные по строкам
    }]);
    alert('Данные измерения сохранены (заглушка). Проверьте консоль.');
  };

  return (
    <CCard className="mb-4">
      {isLoading && (
        <div className="text-center p-3">
          <CSpinner size="sm" />
          <span className="ms-2">Загрузка/Сохранение данных...</span>
        </div>
      )}
      <CCardBody>
        <CNav variant="tabs" role="tablist">
          <CNavItem>
            <CNavLink active={activeKey === 1} onClick={() => setActiveKey(1)}>Сведения</CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink active={activeKey === 2} onClick={() => setActiveKey(2)}>Результаты измерений</CNavLink>
          </CNavItem>
          {/* --- Вкладка 3: Вывод --- */}
          <CNavItem>
            <CNavLink active={activeKey === 3} onClick={() => setActiveKey(3)}>Вывод</CNavLink>
          </CNavItem>
          {/* --- Вкладка 3: Вывод --- */}
          <CNavItem>
            <CNavLink active={activeKey === 4} onClick={() => setActiveKey(4)}>Фото измерений</CNavLink>
          </CNavItem>
        </CNav>
        <CTabContent>
          {/* Вкладка "Сведения" */}
          <CTabPane visible={activeKey === 1}>
            <CTable borderless>
              <CTableBody>
                {[
                  "Объект",
                  "Адрес объекта",
                  "Основание для проведения измерений",
                  "Цель измерений"
                ].map((key, idx) => (
                  <CTableRow key={idx}>
                    <CTableDataCell className="fw-bold" style={{ width: "30%" }}>{key}</CTableDataCell>
                    <CTableDataCell>
                      <CFormInput value={groupedData[key] || ""} readOnly />
                    </CTableDataCell>
                  </CTableRow>
                ))}
                <CTableRow>
                  <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                    Нормативные документы
                  </CTableDataCell>
                  <CTableDataCell>
                    <CFormSelect
                      value={selectedNormativeDoc}
                      onChange={(e) => setSelectedNormativeDoc(e.target.value)}
                      disabled={normativeDocs.length === 0}
                    >
                      {normativeDocs.length > 0 ? (
                        normativeDocs.map((doc, idx) => (
                          <option key={idx} value={doc}>
                            {doc}
                          </option>
                        ))
                      ) : (
                        <option value="">Нет данных</option>
                      )}
                    </CFormSelect>
                  </CTableDataCell>
                </CTableRow>
                <CTableRow>
                  <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                    Средства измерений
                  </CTableDataCell>
                  <CTableDataCell>
                    <CFormSelect
                      value={selectedMeasurementTool}
                      onChange={(e) => setSelectedMeasurementTool(e.target.value)}
                      disabled={measurementToolsOptions.length === 0}
                    >
                      {measurementToolsOptions.length > 0 ? (
                        measurementToolsOptions.map((tool, idx) => (
                          <option key={idx} value={tool}>
                            {tool}
                          </option>
                        ))
                      ) : (
                        <option value="">Нет данных</option>
                      )}
                    </CFormSelect>
                  </CTableDataCell>
                </CTableRow>
                <CTableRow>
                  <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                    Измерения проводил
                  </CTableDataCell>
                  <CTableDataCell>
                    <CFormSelect
                      value={selectedConductedBy}
                      onChange={(e) => setSelectedConductedBy(e.target.value)}
                      disabled={measurementConductedByOptions.length === 0}
                    >
                      {measurementConductedByOptions.length > 0 ? (
                        measurementConductedByOptions.map((person, idx) => (
                          <option key={idx} value={person}>
                            {person}
                          </option>
                        ))
                      ) : (
                        <option value="">Нет данных</option>
                      )}
                    </CFormSelect>
                  </CTableDataCell>
                </CTableRow>
                {/* --- Поля для числовых значений --- */}
                <CTableRow>
                  <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                    Дата проведения измерений
                  </CTableDataCell>
                  <CTableDataCell>
                    <CFormInput
                      type="date"
                      value={dateMeasurement}
                      onChange={(e) => setDateMeasurement(e.target.value)}
                    />
                  </CTableDataCell>
                </CTableRow>
                {Object.entries(groupedData).map(([key, value], idx) => {
                  const skipKeys = [
                    "Объект",
                    "Адрес объекта",
                    "Основание для проведения измерений",
                    "Цель измерений",
                    "№ протокола",
                    "Дата проведения измерений",
                    "Дата протокола",
                    "Ширина основания, мм", // Обрабатывается отдельно
                    "Диаметр пояса, мм" // Обрабатывается отдельно
                  ];
                  if (skipKeys.includes(key)) {
                    return null;
                  }
                  return (
                    <CTableRow key={`other-${idx}`}>
                      <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                        {key}
                      </CTableDataCell>
                      <CTableDataCell>
                        <CFormInput value={value || ""} readOnly />
                      </CTableDataCell>
                    </CTableRow>
                  );
                })}
                <CTableRow>
                  <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                    Дата протокола
                  </CTableDataCell>
                  <CTableDataCell>
                    <CFormInput
                      type="date"
                      value={dateProtocol}
                      onChange={(e) => setDateProtocol(e.target.value)}
                    />
                  </CTableDataCell>
                </CTableRow>
                <CTableRow>
                  <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                    Разработал
                  </CTableDataCell>
                  <CTableDataCell>
                    <CFormSelect
                      value={selectedDevelopedBy}
                      onChange={(e) => setSelectedDevelopedBy(e.target.value)}
                      disabled={developedByOptions.length === 0}
                    >
                      {developedByOptions.length > 0 ? (
                        developedByOptions.map((person, idx) => (
                          <option key={idx} value={person}>
                            {person}
                          </option>
                        ))
                      ) : (
                        <option value="">Нет данных</option>
                      )}
                    </CFormSelect>
                  </CTableDataCell>
                </CTableRow>
              </CTableBody>
            </CTable>
          </CTabPane>
          {/* Вкладка "Результаты измерений" */}
          <CTabPane visible={activeKey === 2}>
            <div className="mb-3 d-flex gap-2">
              <CButton color="secondary" onClick={handleOpenAddModal}>Добавить</CButton>
              <CButton color="secondary">Изменить</CButton>
              <CButton color="secondary">Удалить</CButton>
            </div>
            <CTable bordered>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell>№ яруса</CTableHeaderCell>
                  <CTableHeaderCell>Марка</CTableHeaderCell>
                  <CTableHeaderCell>Натяжение</CTableHeaderCell>
                  <CTableHeaderCell>Разница, %</CTableHeaderCell>
                  <CTableHeaderCell>По проекту, тс</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {measurementsData.length > 0 ? (
                  measurementsData.map((item, index) => (
                    <CTableRow key={index}>
                      <CTableDataCell>{item.floor}</CTableDataCell>
                      <CTableDataCell>{item.brand}</CTableDataCell>
                      <CTableDataCell>{item.tension}</CTableDataCell>
                      <CTableDataCell>-</CTableDataCell> {/* Заглушка */}
                      <CTableDataCell>-</CTableDataCell> {/* Заглушка */}
                    </CTableRow>
                  ))
                ) : (
                  <CTableRow>
                    <CTableDataCell colSpan="5" className="text-center">
                      Данные результатов измерений будут отображаться здесь.
                    </CTableDataCell>
                  </CTableRow>
                )}
              </CTableBody>
            </CTable>
          </CTabPane>
          {/* --- Вкладка 3: Вывод --- */}
          <CTabPane visible={activeKey === 3}>
            <CFormTextarea
              rows={8}
              placeholder="Введите вывод по результатам измерений..."
              value={conclusion}
              onChange={(e) => setConclusion(e.target.value)}
            />
          </CTabPane>
          {/* --- Вкладка 3: Вывод --- */}
          {/* Вкладка "Фото измерений" */}
          <CTabPane visible={activeKey === 4}>
            {photoTabProtocolId ? (
              <PhotoTab idProtocol={photoTabProtocolId} />
            ) : (
              <div className="text-center text-muted">
                Для добавления фото необходимо сначала сохранить протокол.
              </div>
            )}
          </CTabPane>
        </CTabContent>
        <div className="d-flex justify-content-end gap-3 mt-4 pt-2">
          <CButton color="secondary" onClick={() => {/* Логика отмены */ }}>
            Отменить
          </CButton>
          <CButton color="success" onClick={saveData} disabled={isLoading}>
            {isLoading ? 'Сохранение...' : 'Сохранить'}
          </CButton>
        </div>
      </CCardBody>
      
      {/* Модальное окно для добавления измерений */}
      <AddTensionsMeasurements
        visible={isAddModalVisible}
        onClose={() => setIsAddModalVisible(false)}
        onSave={handleSaveMeasurement}
      />
    </CCard>
  );
};
export default ProtocolTensions;